import "./main.css";
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import i18n from "./locales/translator";
import vTranslate from "./shared/config/directive/v-translate";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { PaginationRoot, PaginationList, PaginationListItem } from "reka-ui";
import * as Sentry from "@sentry/vue";

const app = createApp(App);

app.component("Pagination", PaginationRoot);
app.component("PaginationList", PaginationList);
app.component("PaginationListItem", PaginationListItem);

if (import.meta.env.VITE_AMBIENT === "production") {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [ Sentry.browserTracingIntegration({ router }) ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [ "https://nei-market-analytics.com.br" ]
    });
}

app.use(createPinia());
app.use(VueQueryPlugin, {
	enableDevtoolsV6Plugin: import.meta.env.VITE_AMBIENT !== "production",
});
app.use(router);

app.directive("translate", vTranslate);

i18n(app).mount("#app");
